import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-application',
  templateUrl: './confirm-application.component.html',
  styleUrls: ['./confirm-application.component.scss']
})
export class ConfirmApplicationComponent implements OnInit {

  constructor(private dialogRef: MdDialogRef<ConfirmApplicationComponent>) { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/confirm-application/confirm-application.component.ts